import {axiosPrivate} from './axios'
import {useEffect} from 'react'
import useRefreshToken from './useRefreshToken'
import {useAuth} from '../modules/auth/core/Auth'
import {getAuth} from '../modules/auth/core/AuthHelpers'

const useAxiosPrivate = () => {
  const refresh: any = useRefreshToken()
  const {logout} = useAuth()

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization'] && !config.headers['authorization']) {
          const authData = getAuth()
          config.headers['Authorization'] = `Bearer ${authData?.data.access_token}`
        }

        return config
      },
      (err: any) => Promise.reject(err)
    )

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error?.config
        if (error?.response?.status === 401 && !originalRequest?.sent) {
          originalRequest.sent = true
          const newAccessToken = await refresh()
          if (!newAccessToken) {
            logout()
            return Promise.reject(error)
          } else {
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
            return axiosPrivate(originalRequest)
          }
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept)
      axiosPrivate.interceptors.response.eject(responseIntercept)
    }
  }, [logout, refresh])

  return axiosPrivate
}

export default useAxiosPrivate
